var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDevto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.28978 8.296C6.17179 8.20017 6.0257 8.14554 5.87378 8.14044H5.25067V11.872H5.87378C6.02598 11.867 6.17237 11.8123 6.29067 11.7164C6.42844 11.6124 6.49778 11.4569 6.49778 11.2498V8.76267C6.49867 8.55556 6.42756 8.4 6.28978 8.296ZM16.432 2H3.568C2.70311 2 2.00178 2.69956 2 3.56444V16.4356C2.00178 17.3004 2.70311 18 3.568 18H16.4329C17.2978 18 17.9991 17.3004 18.0009 16.4356V3.56444C17.9997 3.14912 17.8339 2.75121 17.5398 2.45794C17.2457 2.16468 16.8473 2 16.432 2ZM7.50667 11.2569C7.50667 11.928 7.09244 12.9467 5.78044 12.944H4.12356V7.03556H5.81511C7.08089 7.03556 7.50578 8.05244 7.50667 8.72356V11.2569ZM11.1022 8.09067H9.2V9.46311H10.3636V10.5191H9.2V11.8907H11.104V12.9467H8.88356C8.69203 12.9514 8.50644 12.88 8.36759 12.748C8.22874 12.6159 8.148 12.4342 8.14311 12.2427V7.77511C8.13858 7.58373 8.21016 7.39838 8.34214 7.25972C8.47413 7.12107 8.65574 7.04045 8.84711 7.03556H11.104L11.1022 8.09067ZM14.8044 12.208C14.3324 13.3058 13.488 13.088 13.1102 12.208L11.7342 7.03645H12.8978L13.9582 11.0978L15.0142 7.03645H16.1787L14.8044 12.208Z",
    fill: "white",
    fillOpacity: 0.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevto);
export default __webpack_public_path__ + "static/media/Devto.57bb3af434150596b0c58a8087494424.svg";
export { ForwardRef as ReactComponent };